/** Keys for school-customizable behaviour terminology labels. */
const LABEL_KEYS = Object.freeze({
  BEHAVIOUR_MANAGEMENT: "behaviourManagement",
  CORE_VALUE: "coreValue",
  POSITIVE_BEHAVIOURS: "positiveBehaviours",
  POINTS: "points"
})

const MAX_LABEL_LENGTH = 25

/** Alphanumeric and spaces only (PBIS functional CSV §2). */
const LABEL_PATTERN = /^[a-zA-Z0-9 ]+$/

/** Admin GET/PUT — `apiV8nocache` base is already `/api/v8`. */
const CUSTOMIZED_THEME_API_PATH = "/admin/pbis/customized-theme-settings"
/** Staff/student GET — `apiV8nocache` base is already `/api/v8`. */
const CUSTOMIZED_THEME_STAFF_API_PATH = "/pbis/customized-theme-settings"

/** API `status` / rename toggle: 0 = disabled (default labels), 1 = enabled (custom labels). */
const RENAME_STATUS = Object.freeze({
  DISABLED: 0,
  ENABLED: 1
})

export default {
  LABEL_KEYS,
  MAX_LABEL_LENGTH,
  LABEL_PATTERN,
  CUSTOMIZED_THEME_API_PATH,
  CUSTOMIZED_THEME_STAFF_API_PATH,
  RENAME_STATUS
}
